<!-- 结缘展示 -->
<template>
  <!-- 結縁品及下載 -->
  <div class="download">
    <div class="conten">
      <!-- 书籍 -->
      <div v-for="(item, index) in contentList" :key="index">
        <div class="book">
          <div class="title">{{ item.cate_name }}</div>
          <div
            class="bookItem flex-start"
            v-for="(item1, index1) in item.lists"
            :key="index1"
          >
            <div class="bookImg flex-center">
              <img :src="item1.goods_url" alt="" />
            </div>
            <div class="bookContent">
              <div class="name">{{ item1.goods_title }}</div>
              <!-- <div class="category">{{$t('downloadCate')}}：{{item1.goods_cate}}</div> -->
              <!--                        <div class="category" @click="topages(item1)">{{$t('downloadConten')}}：{{item1.goods_content}}</div>-->
              <div
                class="category"
                @click="topages(item1)"
                v-if=" index !== 3"
              >
                {{ item1.goods_content }}
              </div>
            </div>
          </div>
        </div>
        <barF5></barF5>
      </div>
      <!-- 音频 -->
      <!-- <div class="book">
                <div class="title">聲音類）</div>
                <div class="bookItem flex-start" v-for="(item,index) in 3" :key="index">
                    <div class="bookImg"><img src="" alt=""></div>
                    <div class="bookContent">
                        <div class="name">《耕雲導師法音集》：包含全部29篇 法音，分成.mp3和.wma 兩種格式，共58個檔案</div>
                        <div class="category">類別：導師法音DVD</div>
                        <div>說明：內容與網站相同，歡迎禪友下載聆聽， 以免浪費資源。</div>
                    </div>
                </div>
            </div>
            <barF5></barF5> -->
      <!-- 影视 -->
      <!-- <div class="book">
                <div class="title">錄影類</div>
                <div class="bookItem flex-start" v-for="(item,index) in 3" :key="index">
                    <div class="bookImg"><img src="" alt=""></div>
                    <div class="bookContent">
                        <div class="name">《耕雲導師禪學講話錄影 DVD 》：</div>
                        <div class="category">類別：導師說法</div>
                        <div>包含： 1．耕雲導師簡介 2．禪的認知與修學 3．佛法在世間</div>
                    </div>
                </div>
            </div>
            <barF5></barF5> -->
      <!-- 限定订阅 -->
      <!-- <div class="order ">

                <div class="title">限定贈閱</div>
                <div class="note">注：下列書籍只贈送給捐款本會新台幣2000元以上的捐款者，非捐款者 請勿索取</div>
               <div class="flex-between">
                <div class="flex-column-start" v-for="(iem,index) in 3" :key="index">
                    <div class="orderImg"><img src="" /></div>
                    <div class="name">《耕雲導師詩歌與 銘言 》平裝本</div>
                    <div class="category">類別：導師著作</div>
                </div>
               </div>

            </div>
            <barF5></barF5> -->
      <!-- 索取方法 -->
      <div class="getMethod">
        <div class="title">{{ acquisition.title }}</div>
        <div v-html="acquisition.content"></div>
      </div>
    </div>

    <!-- 底部button -->
    <!-- <footer>
            <Button></Button>
        </footer> -->
  </div>
</template>

<script>
import { getAcquisitionList } from "../../api/apis";
import barF5 from "../../components/barF5"; //空隙bar
import Button from "../../components/button"; //返回首頁
export default {
  name: "show",
  components: {
    barF5,

    Button,
  },
  props: {
    contentList: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    contentList(val) {
      console.log(val);
    },
  },
  data() {
    return {
      acquisition: {},
      // books: {
      //     title: "書籍（繁體版）",
      //     list: [{
      //         img: "",
      //         name: "書籍（繁體版）",
      //         brief: "導師講詞",
      //         content: "請參閱「耕雲導師講詞」"
      //     }]
      // },
      // audio: {
      //     title: "聲音類",
      //     list: [{
      //         img: "",
      //         name: "《耕雲導師法音集》：包含全部29篇法音，分成.mp3和.wma 兩種格式，共58個檔案",
      //         brief: "導師講詞",
      //         content: "請參閱「耕雲導師講詞」"
      //     }]
      // },
      // video: {
      //     title: "書籍（繁體版）",
      //     list: [{
      //         img: "",
      //         name: "書籍（繁體版）",
      //         brief: "導師講詞",
      //         content: "請參閱「耕雲導師講詞」"
      //     }]
      // }
    };
  },
  methods: {
    topages(item1) {
      window.open(item1.link_m, "_self");
    },
  },
  mounted() {
    getAcquisitionList().then((res) => {
      this.acquisition = res;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.book,
.getMethod {
  color: #333333;
}

.book .title {
  padding: 1rem 0.64rem 0.2rem 0.64rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.bookItem {
  font-size: 0.59rem;
  border-bottom: 1px dashed #dfdfdf;
  padding: 0.64rem;
}
.bookImg {
  width: 8.93rem;
  height: 8rem;
  background: rgba(244, 243, 238, 1);
  flex-shrink: 0;
}
.bookImg img {
  width: 6rem;
}

.bookContent {
  padding: 0.53rem;
  line-height: 1rem;
}

.name {
  /* font-size: 0.69rem; */
  font-size: 0.85rem;
  line-height: 1.1rem;
}

.category {
  color: #047bcd;
  background-color: #cceaff;
  display: inline-block;
  padding: 0rem 0.5rem;
  margin: 0.64rem 0rem;
}

.getMethod {
  font-size: 0.69rem;
  line-height: 1rem;
  padding: 0.64rem;
  font-size: 0.8rem;
  line-height: 1.3rem;
}

.getMethod .title {
  font-size: 0.8rem;
  line-height: 1.4rem;
  margin-bottom: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
}

.order {
  padding: 0.64rem;
  line-height: 1rem;
}
.order .title {
  font-size: 0.8rem;
  line-height: 1.6rem;
  font-size: 0.85rem;
  font-weight: 600;
}
.note {
  font-size: 0.59rem;
  color: #fc0000;
}
.orderImg {
  width: 5.76rem;
  height: 8rem;
  background: rgba(244, 243, 238, 1);
  margin: 0.64rem 0rem;
}
</style>